import { Typography } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

type PlaceholderSettings = { font?: string; fontSize?: number; offset?: number };

export const DefaultPlaceholder: FC<{
  placeholderSettings?: PlaceholderSettings;
  text?: string;
}> = ({ placeholderSettings, text }) => {
  const { t } = useTranslation();

  return (
    <Typography
      data-testid="editor-placeholder-text"
      sx={{
        color: "gray",
        position: "absolute",
        top: 4 + (placeholderSettings?.fontSize ?? 13) + (placeholderSettings?.offset ?? 0),
        left: 30 + (placeholderSettings?.offset ?? 0),
        userSelect: "none",
        pointerEvents: "none",
        ...(placeholderSettings
          ? {
              fontFamily: placeholderSettings.font,
              fontSize: placeholderSettings.fontSize,
            }
          : {}),
      }}
    >
      {text ?? t("Enter message...")}
    </Typography>
  );
};
